import React from 'react';
import { BasicTable } from './BasicTable/BasicTable';

const ManagePaymentLogsComponent: React.FC = () => {
    return (
        <>
            <div style={{ marginBottom: '20px', flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ fontWeight: 'bold' }}>Payment Audit Logs</h4>
            </div>
            <BasicTable />
        </>
    );
};

export default ManagePaymentLogsComponent;
